import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import {errorEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {numWithStarRTL} from '../../../../utilities/StringHelpers/StringHelpers';
import {CSSTransition} from 'react-transition-group';
import Config from '../../../../Config';
import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const ContactUsError = (props) => {
  const [mount, setMount] = useState(false);

  useEffect(() => {
    if (props.currentStep === errorEnum.CONTACTUS) {
      setMount(true);
      if (props.isPrivate) {
        gaEvent(
          gaParams.PRIVATEDEBT_CONTACTME_SENTFAILED_SHOW.category,
          gaParams.PRIVATEDEBT_CONTACTME_SENTFAILED_SHOW.eventType,
          gaParams.PRIVATEDEBT_CONTACTME_SENTFAILED_SHOW.eventParams,
        );
      } else {
        gaEvent(
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUSERROR.category,
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUSERROR.eventType,
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUSERROR.eventParams,
        );
      }
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  let mainImg = require('../images/icons-error.svg');

  return (
    <CSSTransition key={13} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='רק רגע, הפנייה לא נשלחה' classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='justify-content-md-center main-img'>
          <Col md='auto'>
            <BasicImage src={mainImg} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'אפשר לנסות שוב או לפנות אל\n מוקד השירות שלנו ב-' + numWithStarRTL(Config.businessCallNumber)} />
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit isBusiness={!props.isPrivate} formid='' text='סיום' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default ContactUsError;
